import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { commonFiltersValue } from "@signals"
import { evolutionOffersDataFilters, evolutionOffersCurrentPeriod, priceDiscountEndDate } from "../../@signals"


export default function PriceDiscountOffersChartFooter() {
    const newFilters = commonFiltersValue.peek()

    const handleClick = () => { batch(() => {
        priceDiscountEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, priceDiscountEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionOffersCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        evolutionOffersDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: priceDiscountEndDate.value,
        }})
    }
	
	return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', mt: 2, cursor: 'pointer'}} onClick={handleClick}>
        <IconSeeker icon={'chart-line'} sx={{ mr: .5,  color: 'primary.main'}}/>
        <Typography variant="body2" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5,  "&:hover": { textDecoration: 'underline'} }}>
            Show Evolution
        </Typography>
    </Box>
}